import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_LOG_FILTER_LOADING = 'GET_LOG_FILTER_LOADING';
export const GET_LOG_FILTER_SUCCESS = 'GET_LOG_FILTER_SUCCESS';
export const GET_LOG_FILTER_REJECT = 'GET_LOG_FILTER_REJECT';

//* ACTIONS ------------------------------------------------
export const getLogFilterLoading = () => ({ type: GET_LOG_FILTER_LOADING });
export const getLogFilterSuccess = (payload) => ({ type: GET_LOG_FILTER_SUCCESS, payload });
export const getLogFilterReject = (payload) => ({ type: GET_LOG_FILTER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getLogFilterRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Logs/web/GetLogsFilters`, options);
};

